module.exports = __webpack_public_path__ + "static/media/vf_wsneakers_core.a903607a.svg";